export function renderPanelLegend(parentElem, panel, panelLayout) {

	let x = panelLayout.x + 4;
	let y = panelLayout.y - 14;

	const boxWidth = 12;
	const boxHeight = 10;
	const boxLabelSpacing = 4;
	const itemSpacing = 25;

	panel.config.series.forEach(s => {

		const box = parentElem.append('rect')
			.attr('class', `hw_panel_graph_legend_box hw_panel_graph_legend_box_${s.config.name}`)
			.attr('x', x)
			.attr('y', y)
			.attr('width', boxWidth)
			.attr('height', boxHeight);

		if (s.config.color !== null) {
			box.style('fill', s.config.color);
		}

		const text = parentElem.append('text')
			.attr('class', `hw_panel_graph_legend_label hw_panel_graph_legend_label_${s.config.name}`)
			.attr('x', x + boxWidth + boxLabelSpacing)
			.attr('y', y + 9)
			.text(s.config.label || s.config.name);

		const textDim = text.node().getBBox();

		if (x + boxWidth + boxLabelSpacing + textDim.width + 10 > panelLayout.x + panelLayout.width) {

			y += (textDim.height + 4);
			x = panelLayout.x + 4;

			box.attr('x', x)
				.attr('y', y);

			text.attr('x', x + boxWidth + boxLabelSpacing)
				.attr('y', y + 9);

		}

		x += (boxWidth + boxLabelSpacing + textDim.width + itemSpacing);

	});

}



// WEBPACK FOOTER //
// ./utils/panelgraph/functions/render-panel-legend.js